import BookmarkSolid from '@assets/icons/bookmark-solid.svg'
import { Icon } from './Icon'

export const BookmarkSolidIcon = Icon(BookmarkSolid)
